/* DevUI mobile toolbar: image-only collection cards + Others quick-links popover. */
(() => {
  const ROOT_ID = 'DevuiMobileBottomNav';
  const STYLE_ID = 'DevuiMobileToolbarOthersStyles';
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let lastFocused = null;
  let gridObserver = null;

  const shopRoot = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const icons = {
    more: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="5" cy="12" r="1.45"/><circle cx="12" cy="12" r="1.45"/><circle cx="19" cy="12" r="1.45"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6.5 6.5 11 11M17.5 6.5l-11 11"/></svg>',
    about: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4.5h10.2A2.8 2.8 0 0 1 18 7.3V20H7.8A2.8 2.8 0 0 1 5 17.2V4.5Z"/><path d="M8.5 8h6M8.5 11.5H14M8.5 15h4.2"/></svg>',
    contact: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 5.5h15v10.7h-8.2L7 20v-3.8H4.5V5.5Z"/><path d="M8 9h8M8 12.5h5.3"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M14 7l5 5-5 5"/></svg>'
  };

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media (min-width:750px){#${ROOT_ID} .do-layer{display:none!important}}
      @media (max-width:749px){
        body.devui-others-lock{overflow:hidden!important;overscroll-behavior:none}
        #${ROOT_ID} .dn-item[data-nav="others"] .dn-icon svg{fill:currentColor;stroke:none;width:23px;height:23px}
        #${ROOT_ID} .do-layer{position:fixed;inset:0;z-index:86;visibility:hidden;pointer-events:none;font-family:var(--font-body--family,inherit)}
        #${ROOT_ID} .do-backdrop{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;border:0;background:rgba(39,24,27,.24);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);opacity:0;transition:opacity .2s ease}
        #${ROOT_ID} .do-panel{position:absolute;left:50%;bottom:calc(88px + env(safe-area-inset-bottom,0px));width:min(calc(100vw - 24px),360px);overflow:hidden;border:1px solid rgba(170,51,65,.13);border-radius:23px;background:rgba(255,252,250,.99);box-shadow:0 18px 54px rgba(61,31,36,.22),0 3px 12px rgba(61,31,36,.08);transform:translate(-50%,14px) scale(.985);opacity:0;transition:transform .24s cubic-bezier(.2,.8,.2,1),opacity .2s ease}
        #${ROOT_ID} .do-layer.open{visibility:visible;pointer-events:auto}
        #${ROOT_ID} .do-layer.open .do-backdrop{opacity:1}
        #${ROOT_ID} .do-layer.open .do-panel{opacity:1;transform:translate(-50%,0) scale(1)}
        #${ROOT_ID} .do-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;padding:15px 15px 11px;border-bottom:1px solid rgba(170,51,65,.09)}
        #${ROOT_ID} .do-kicker{margin:0 0 3px;color:#aa3341;font-size:9px;line-height:1;font-weight:750;letter-spacing:.1em;text-transform:uppercase}
        #${ROOT_ID} .do-title{margin:0;color:#462e31;font-family:var(--font-heading--family,inherit);font-size:18px;line-height:1.1;font-weight:650;letter-spacing:-.018em}
        #${ROOT_ID} .do-sub{margin:4px 0 0;color:#806b6e;font-size:10px;line-height:1.35}
        #${ROOT_ID} .do-close{display:grid;flex:0 0 34px;width:34px;height:34px;margin:0;padding:0;place-items:center;border:1px solid rgba(170,51,65,.11);border-radius:50%;background:#fff;color:#6f5256;box-shadow:0 3px 10px rgba(70,46,49,.06);cursor:pointer}
        #${ROOT_ID} .do-close svg{width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:1.75;stroke-linecap:round}
        #${ROOT_ID} .do-links{display:grid;gap:8px;padding:10px}
        #${ROOT_ID} .do-link{display:grid;grid-template-columns:42px minmax(0,1fr) 28px;min-height:62px;align-items:center;gap:10px;padding:8px 9px;border:1px solid rgba(170,51,65,.095);border-radius:17px;background:#fff;color:#462e31;text-decoration:none;box-shadow:0 4px 14px rgba(70,46,49,.04);-webkit-tap-highlight-color:transparent;transition:transform .16s ease,border-color .16s ease,background .16s ease}
        #${ROOT_ID} .do-link:active{transform:scale(.985);background:#fff7f6}
        #${ROOT_ID} .do-link__icon{display:grid;width:42px;height:42px;place-items:center;border-radius:13px;background:#fff0f2;color:#aa3341}
        #${ROOT_ID} .do-link__icon svg{width:21px;height:21px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
        #${ROOT_ID} .do-link__copy{min-width:0}
        #${ROOT_ID} .do-link__copy strong{display:block;margin:0;color:#462e31;font-size:12px;line-height:1.15;font-weight:700}
        #${ROOT_ID} .do-link__copy small{display:block;margin-top:3px;color:#806b6e;font-size:9.5px;line-height:1.3;font-weight:450}
        #${ROOT_ID} .do-link__arrow{display:grid;width:28px;height:28px;place-items:center;border-radius:50%;background:#fff6f5;color:#aa3341}
        #${ROOT_ID} .do-link__arrow svg{width:15px;height:15px;fill:none;stroke:currentColor;stroke-width:1.65;stroke-linecap:round;stroke-linejoin:round}
        #${ROOT_ID} .do-link[aria-current="page"]{border-color:rgba(170,51,65,.28);background:#fff7f6}
        #${ROOT_ID} :is(.do-link,.do-close):focus-visible{outline:2px solid #aa3341;outline-offset:2px}
        @media(max-width:359px){#${ROOT_ID} .do-panel{width:calc(100vw - 16px);bottom:calc(84px + env(safe-area-inset-bottom,0px))}}
        @media(prefers-reduced-motion:reduce){#${ROOT_ID} .do-layer *,#${ROOT_ID} .do-layer *:before,#${ROOT_ID} .do-layer *:after{transition-duration:.01ms!important}}
      }`;
    document.head.appendChild(style);
  };

  const currentPath = () => {
    const path = String(location.pathname || '/').replace(/\/+$/, '');
    return path || '/';
  };

  const pageHref = (handle) => `${shopRoot()}pages/${handle}`;

  const cleanImageLessCollections = (root) => {
    const grid = root.querySelector('[data-grid]');
    if (!grid) return;

    grid.querySelectorAll('.cc').forEach((card) => {
      if (card.querySelector('.cc-fallback')) card.remove();
    });

    const cards = [...grid.querySelectorAll('[data-card]')];
    const meta = root.querySelector('[data-meta]');
    if (meta && cards.length) {
      meta.textContent = `${cards.length} collection${cards.length === 1 ? '' : 's'} from the menu.`;
    }
  };

  const watchCollectionGrid = (root) => {
    const grid = root.querySelector('[data-grid]');
    if (!grid) return;
    cleanImageLessCollections(root);
    if (gridObserver) gridObserver.disconnect();
    gridObserver = new MutationObserver(() => cleanImageLessCollections(root));
    gridObserver.observe(grid, { childList: true, subtree: true });
  };

  const convertCartToOthers = (root) => {
    let item = root.querySelector('[data-nav="others"]');
    if (!item) item = root.querySelector('[data-nav="cart"]');
    if (!item) return null;

    item.dataset.nav = 'others';
    item.dataset.action = 'others';
    item.removeAttribute('href');
    item.setAttribute('type', 'button');
    item.setAttribute('aria-label', 'More pages');
    item.setAttribute('aria-controls', 'DevuiOthersPopover');
    item.setAttribute('aria-expanded', 'false');
    item.querySelector('[data-cart-count]')?.remove();

    const icon = item.querySelector('.dn-icon');
    const label = item.querySelector('.dn-label');
    if (icon) icon.innerHTML = icons.more;
    if (label) label.textContent = 'Others';

    const p = currentPath();
    const active = p.endsWith('/pages/about-us') || p.endsWith('/pages/contact');
    item.dataset.active = active ? 'true' : 'false';
    if (active) item.setAttribute('aria-current', 'page');
    else item.removeAttribute('aria-current');

    return item;
  };

  const buildPopover = (root) => {
    let layer = root.querySelector('#DevuiOthersPopover');
    if (layer) return layer;

    const aboutHref = pageHref('about-us');
    const contactHref = pageHref('contact');
    const p = currentPath();

    layer = document.createElement('div');
    layer.id = 'DevuiOthersPopover';
    layer.className = 'do-layer';
    layer.setAttribute('aria-hidden', 'true');
    layer.innerHTML = `
      <button class="do-backdrop" type="button" data-others-close tabindex="-1" aria-label="Close more pages"></button>
      <section class="do-panel" role="dialog" aria-modal="true" aria-labelledby="DevuiOthersTitle" tabindex="-1">
        <header class="do-head">
          <div><p class="do-kicker">Quick links</p><h2 class="do-title" id="DevuiOthersTitle">More</h2><p class="do-sub">Store information and support.</p></div>
          <button class="do-close" type="button" data-others-close aria-label="Close">${icons.close}</button>
        </header>
        <div class="do-links">
          <a class="do-link" href="${aboutHref}" ${p.endsWith('/pages/about-us') ? 'aria-current="page"' : ''}>
            <span class="do-link__icon">${icons.about}</span>
            <span class="do-link__copy"><strong>About Us</strong><small>Our story, values & craft</small></span>
            <span class="do-link__arrow">${icons.arrow}</span>
          </a>
          <a class="do-link" href="${contactHref}" ${p.endsWith('/pages/contact') ? 'aria-current="page"' : ''}>
            <span class="do-link__icon">${icons.contact}</span>
            <span class="do-link__copy"><strong>Contact Us</strong><small>Questions, orders & support</small></span>
            <span class="do-link__arrow">${icons.arrow}</span>
          </a>
        </div>
      </section>`;
    root.appendChild(layer);
    return layer;
  };

  const closeOthers = (root, restoreFocus = true) => {
    const layer = root.querySelector('#DevuiOthersPopover');
    const trigger = root.querySelector('[data-action="others"]');
    if (!layer?.classList.contains('open')) return;

    layer.classList.remove('open');
    layer.setAttribute('aria-hidden', 'true');
    trigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('devui-others-lock');

    const p = currentPath();
    const active = p.endsWith('/pages/about-us') || p.endsWith('/pages/contact');
    if (trigger) trigger.dataset.active = active ? 'true' : 'false';

    if (restoreFocus && lastFocused?.focus) {
      window.setTimeout(() => lastFocused.focus({ preventScroll: true }), 30);
    }
  };

  const openOthers = (root) => {
    if (!mobileQuery.matches) return;
    const layer = buildPopover(root);
    const trigger = root.querySelector('[data-action="others"]');
    if (!layer || layer.classList.contains('open')) return;

    const openCollections = root.querySelector('[data-layer].open [data-close]');
    if (openCollections instanceof HTMLElement) openCollections.click();

    lastFocused = document.activeElement instanceof HTMLElement ? document.activeElement : trigger;
    layer.classList.add('open');
    layer.setAttribute('aria-hidden', 'false');
    trigger?.setAttribute('aria-expanded', 'true');
    if (trigger) trigger.dataset.active = 'true';
    document.body.classList.add('devui-others-lock');

    window.setTimeout(() => layer.querySelector('.do-close')?.focus({ preventScroll: true }), 40);
  };

  const bind = (root) => {
    if (root.dataset.othersReady === 'true') return;
    root.dataset.othersReady = 'true';

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-action="others"]');
      if (trigger && root.contains(trigger)) {
        event.preventDefault();
        openOthers(root);
        return;
      }

      if (event.target.closest('[data-others-close]')) {
        event.preventDefault();
        closeOthers(root);
      }
    });

    document.addEventListener('keydown', (event) => {
      const layer = root.querySelector('#DevuiOthersPopover');
      if (!layer?.classList.contains('open')) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeOthers(root);
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = [...layer.querySelectorAll('a[href],button:not([disabled])')].filter((el) => el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const onMediaChange = (event) => {
      if (!event.matches) closeOthers(root, false);
    };
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onMediaChange);
    else mobileQuery.addListener?.(onMediaChange);
  };

  const boot = () => {
    if (!mobileQuery.matches) return;
    const root = document.getElementById(ROOT_ID);
    if (!root) {
      window.setTimeout(boot, 80);
      return;
    }

    injectStyles();
    convertCartToOthers(root);
    buildPopover(root);
    watchCollectionGrid(root);
    bind(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => window.setTimeout(boot, 0));
})();
